module.exports = __webpack_public_path__ + "static/media/TWO.fa4b39fb.png";